import React from 'react'
import { FormProvider } from 'react-hook-form'
import { StartingHeader, IconWrapper } from './styled'
import { IoChevronBackOutline } from 'react-icons/io5'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { routes } from '../../../constants/routes'
import { appsOrigin } from '../../../constants/appOrigin'
import { ControllerInput } from '../../shared/Input/ControllerInput'
import { Button } from '../../shared/simple/Button'
import { RouterLink } from '../../shared/simple/RouterLink'
import { Label } from '../../shared/simple/Label'
import { Link } from 'react-router-dom'
import { envSetting } from '../../../constants/envSetting'
import { LoaderSpinner } from '../../shared/simple/LoaderSpinner'
import { motion } from 'motion/react';
import { SlideViewport, SlideTrack, SlidePanel } from './styled'
import RegisterSuccessful from './RegisterSuccessful'
import { LinkText } from '../../tier/styled'

const RegisterForm = ({
  methods,
  handleSubmit,
  onNewRegister,
  loading,
  appOrigin,
  errors,
  switchMailSent,
  isSignUpMailSent,
  mailValues,
  tick,
  setTick,
  isSending
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { register } = methods

  const altErrorMessageStyle = {
    display: 'block',
    color: '#FF7171',
    backgroundColor: 'rgba(255, 113, 113, 0.12)',
    borderLeft: '3px solid #FF7171',
    padding: '8px 12px',
    borderRadius: '6px',
    fontSize: '0.875em',
    fontWeight: 500,
    marginTop: '6px',
    width: 'fit-content',
    textAlign: 'left'
  }; 

  const goDefaultProductSelection = () => {
    navigate(routes.getStartedEmail(appsOrigin.default))
  }

  return (
    <SlideViewport>
      <FormProvider {...methods}>
        <SlideTrack
          animate={{ x: !isSignUpMailSent ? '0%' : '-50%' }}
          transition={{ duration: 0.25, ease: 'easeInOut' }}
        >
          <SlidePanel
            style={{ display: 'flex', justifyContent: 'center' }}
          >
              <form 
                style={{ width: '400px' }} 
                onSubmit={handleSubmit(onNewRegister)}
              >
                <StartingHeader>
                  <h1>{ t("getStarted.getStarted") }</h1>
                  {/* Icon to go back */}
                  <IconWrapper onClick={goDefaultProductSelection} >
                    <IoChevronBackOutline size={24} style={{ cursor: 'pointer' }} />
                  </IconWrapper>
                </StartingHeader>
                <ControllerInput
                  autoComplete="off"
                  disabled={ loading }
                  label={ t("common.email") }
                  message={ errors.email?.message }
                  name={ register("email").name }
                  placeholder={ t("common.emailExample") }
                  control={ methods?.control }
                  type="email"
                  labelColor="white"
                  altErrorStyle={altErrorMessageStyle}
                />
                {loading
                  ? (
                    <LoaderSpinner />
                  ) : (
                    <Button
                      className="btn mb-0"
                      disabled={ loading }
                      color="first"
                      type="submit"
                      name="btn_email"
                    >
                      { t("common.continue") }
                    </Button>
                  )
                }
                <Label className="wantText" color="white">
                  {!loading && <>
                    { t("getStarted.signUp") }&nbsp;
                    <RouterLink
                      className="p-0 col-12"
                      to={ routes.login(appOrigin) }
                      color={'third'}
                      disabled={ loading }
                    >
                      { t("login.buttonLogIn") }
                    </RouterLink>
                  </>}
                </Label>
                <Label className="wantText" color="white">
                  { t("common.createAccount") }&nbsp;
                  <LinkText
                    className="p-0 col-12"
                    href={ envSetting?.routeCreateAccount }
                    color="third"
                    target="_blank"
                  >
                    { t("common.createAccountURL") }
                  </LinkText>
                </Label>
              </form>
          </SlidePanel>
          <SlidePanel>
            <RegisterSuccessful 
              switchMailSent={switchMailSent}
              mailValues={mailValues}
              isSignUpMailSent={isSignUpMailSent}
              tick={tick}
              setTick={setTick}
              isSending={isSending}
            />
          </SlidePanel>
        </SlideTrack>
      </FormProvider>
    </SlideViewport>
  )
}

export default RegisterForm